<div class="container create-kuar my-4">
  <h3 class="mb-3">{{ 'EMAILSCANNER_KUAR_TITLE' | translate }}</h3>

  @if (!customerId || !kArtnr) {
    <div class="alert alert-danger">{{ 'EMAILSCANNER_KUAR_INVALID_LINK' | translate }}</div>
  } @else {
    @if (previewFailed) {
      <div class="alert alert-danger">{{ 'EMAILSCANNER_KUAR_TECHNICAL_ERROR' | translate }}</div>
    }
    @if (preview && !preview.customerFound) {
      <div class="alert alert-danger">{{ 'EMAILSCANNER_KUAR_CUSTOMER_NOT_FOUND' | translate: { customerId: customerId } }}</div>
    }

    @if (ooArtnrMissingInLink && !created) {
      <p>{{ 'EMAILSCANNER_KUAR_ENTER_OO_ARTNR' | translate: { kArtnr: kArtnr } }}</p>
    }

    <div class="row mb-3">
      <label class="col-sm-3 col-form-label fw-bold">{{ 'CUSTOMER' | translate }}</label>
      <div class="col-sm-9">
        <input type="text" readonly class="form-control-plaintext" [value]="customerId + (preview?.customerName ? ' - ' + preview.customerName : '')" />
      </div>
    </div>
    <div class="row mb-3">
      <label class="col-sm-3 col-form-label fw-bold">{{ 'EMAILSCANNER_KUAR_K_ARTNR' | translate }}</label>
      <div class="col-sm-9">
        <input type="text" readonly class="form-control-plaintext" [value]="kArtnr" />
      </div>
    </div>
    <div class="row mb-3">
      <label for="ooArtnr" class="col-sm-3 col-form-label fw-bold">{{ 'EMAILSCANNER_KUAR_OO_ARTNR' | translate }}</label>
      <div class="col-sm-9">
        <input
          id="ooArtnr"
          type="text"
          class="form-control"
          autocomplete="off"
          [ngModel]="ooArtnr"
          (ngModelChange)="onOoArtnrChange($event)"
          [disabled]="creating || created"
        />
        @if (ooArtnrEntered && !loadingPreview && preview) {
          @if (preview.productFound) {
            <small class="form-text text-muted">{{ preview.productId }} - {{ preview.productName }}</small>
          } @else {
            <small class="form-text text-danger">{{ 'EMAILSCANNER_KUAR_PRODUCT_NOT_FOUND' | translate: { ooArtnr: ooArtnr } }}</small>
          }
        }
      </div>
    </div>

    @if (!created && preview && !loadingPreview) {
      @if (alreadyExists) {
        <div class="alert alert-info">{{ 'EMAILSCANNER_KUAR_ALREADY_EXISTS' | translate }}</div>
      }
      @if (replacesExistingKArtnr) {
        <div class="alert alert-warning">
          {{ 'EMAILSCANNER_KUAR_REPLACES_EXISTING' | translate: { existingKArtnr: preview.existingKArtnrForProduct, kArtnr: kArtnr } }}
        </div>
      }
      @if (preview.kArtnrLinkedToProductIds?.length > 0) {
        <div class="alert alert-warning">
          {{ 'EMAILSCANNER_KUAR_K_ARTNR_LINKED_ELSEWHERE' | translate: { kArtnr: kArtnr, ooArtnrs: preview.kArtnrLinkedToProductIds.join(', ') } }}
        </div>
      }
    }

    @if (result?.status === 'CREATED') {
      <div class="alert alert-success">{{ 'EMAILSCANNER_KUAR_CREATED' | translate }}</div>
    }
    @if (result?.status === 'ALREADY_EXISTS') {
      <div class="alert alert-info">{{ 'EMAILSCANNER_KUAR_ALREADY_EXISTS' | translate }}</div>
    }
    @if (result?.status === 'INVALID') {
      <div class="alert alert-warning">{{ result.message }}</div>
    }
    @if (technicalError) {
      <div class="alert alert-danger">{{ 'EMAILSCANNER_KUAR_TECHNICAL_ERROR' | translate }}</div>
    }

    @if (!created) {
      <button type="button" class="btn btn-primary" (click)="create()" [disabled]="!canCreate">
        @if (creating) {
          <i class="fa fa-spinner fa-spin me-1"></i>
        }
        {{ 'EMAILSCANNER_KUAR_CREATE' | translate }}
      </button>
    }
  }
</div>
